var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('SpinnerWave',{attrs:{"color":"#666"}}),_c('iframe',{ref:"courseIframe",staticStyle:{"display":"none"},attrs:{"src":_vm.appUrl + 'login-integration',"width":"0","height":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }